import moment from 'moment-timezone';

/** Returns a moment for the value in the given timezone, or local time when tz is omitted. */
function toMomentInTimezone(value: string | Date, tz?: string) {
  return tz ? moment(value).tz(tz) : moment(value);
}

/** Returns true when the value falls on today's calendar day in the given timezone. */
export function isTodayInTimezone(value: string | Date, tz?: string): boolean {
  const date = toMomentInTimezone(value, tz);
  const today = tz ? moment().tz(tz) : moment();
  return date.isSame(today, 'day');
}

/** Returns true when the value falls on yesterday's calendar day in the given timezone. */
export function isYesterdayInTimezone(value: string | Date, tz?: string): boolean {
  const date = toMomentInTimezone(value, tz);
  const yesterday = tz ? moment().tz(tz).subtract(1, 'day') : moment().subtract(1, 'day');
  return date.isSame(yesterday, 'day');
}
